import { z } from 'zod';
import { LocationType } from '../../constants/location-type.js';
import { requiredUuidString } from '../zod-helpers/index.js';
import { LOCATION_CONSTRAINTS } from './constraints.js';
import { locationDescriptionSchema, locationNameSchema } from './update-form.js';
export const createLocationInputSchema = z
    .object({
    name: z.string(),
    description: z.string().optional().nullable(),
    locationGroupId: requiredUuidString(`${LOCATION_CONSTRAINTS.locationGroupId.label} is required.`, `Invalid ${LOCATION_CONSTRAINTS.locationGroupId.label.toLowerCase()} selection.`),
    typeId: z.enum(LocationType, 'Invalid location type selection.'),
    activeFlag: z.boolean().optional().nullable(),
    pickable: z.boolean().optional().nullable(),
    receivable: z.boolean().optional().nullable(),
    countedAsAvailable: z.boolean().optional().nullable(),
})
    .superRefine((input, context) => {
    const nameResult = locationNameSchema.safeParse(input.name);
    if (!nameResult.success) {
        context.addIssue({
            code: 'custom',
            message: nameResult.error.issues[0].message,
            path: ['name'],
        });
    }
    if (input.description != null && input.description !== '') {
        const descriptionResult = locationDescriptionSchema.safeParse(input.description);
        if (!descriptionResult.success) {
            context.addIssue({
                code: 'custom',
                message: descriptionResult.error.issues[0].message,
                path: ['description'],
            });
        }
    }
});
//# sourceMappingURL=create-input.js.map